import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import messages from './simulatedCorrectionMessages';

const SimulatedCorrectionAnswerListActionButton = props => {
  switch (true) {
    case Number(props.corrected) === 0:
      return (
        <button onClick={props.onUpload}>
          <div className="card-item-action">
            <i className="ti-upload pending" />
            <FormattedMessage {...messages.upload}>
              {txt => <span className="pending">{txt}</span>}
            </FormattedMessage>
          </div>
        </button>
      );
    case Number(props.corrected) === 1:
      return (
        <button onClick={props.onSee}>
          <div className="card-item-action corrected">
            <i className="pe-7s-search pending" />
            <FormattedMessage {...messages.see}>
              {txt => <span className="pending">{txt}</span>}
            </FormattedMessage>
          </div>
        </button>
      );
    case Number(props.corrected) === 2:
      return (
        <>
        <i className="ti-alert alert-auditing" />
        <button onClick={props.onAudit}>
          <div className="card-item-action auditing">
            <i className="ti-pencil pending" />
            <FormattedMessage {...messages.audit}>
              {txt => <span className="pending">{txt}</span>}
            </FormattedMessage>
          </div>
        </button>
        </>
      );
    default:
      return (
        <button onClick={props.onUpload}>
          <div className="card-item-action">
            <i className="ti-upload pending" />
            <FormattedMessage {...messages.upload}>
              {txt => <span className="pending">{txt}</span>}
            </FormattedMessage>
          </div>
        </button>
      );
  }
};

SimulatedCorrectionAnswerListActionButton.propTypes = {};

export default SimulatedCorrectionAnswerListActionButton;
